'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFloppyDiskCheckmark, iconFloppyDiskCheckmarkTag } from '@ni/nimble-components/dist/esm/icons/floppy-disk-checkmark';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFloppyDiskCheckmark };
export { iconFloppyDiskCheckmarkTag };
export const NimbleIconFloppyDiskCheckmark = wrap(IconFloppyDiskCheckmark);